var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0297 10.1124L20.0297 10.1124L29.3385 18.6765L29.3385 18.6765L29.5 18.825V30.0445H23.25V23.1695V22.1695H22.25H17.75H16.75V23.1695V30.0445H10.5V18.8374L10.6464 18.691L10.6465 18.6909L19.2079 10.1295L18.5008 9.42237L19.2079 10.1295C19.3162 10.0211 19.4622 9.95888 19.6153 9.9557C19.7685 9.95251 19.917 10.0086 20.0297 10.1124Z",
    stroke: "#1F1F1F",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.1d864d9ac650171eae44dbc78577a8c4.svg";
export { ForwardRef as ReactComponent };